import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { ProjectListStateService } from '@modules/tasks/services/project-list-state.service';
import { ProjectsService } from '@modules/tasks/services/projects.service';
import { Project } from '@modules/tasks/types/project';
import { ProjectsFilters } from '@modules/tasks/types/projects-filters';
import { ProjectsListState } from '@modules/tasks/types/projects-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-projects-section',
  templateUrl: './projects-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...ProjectListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeProjectsSectionComponent
  extends KnowledgeStitchSectionComponent<Project, ProjectsFilters>
  implements OnInit
{
  protected readonly listStateService = inject(ProjectListStateService, { self: true });
  protected readonly stitchService = inject(ProjectsService);

  public override ngOnInit(): void {
    this.state = new ProjectsFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: ProjectsListState): void {
    this.filterChange.emit();

    this.filters = new ProjectsFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
